import { EinvoiceValidationresult } from '../../../../data/models'
import { getTransformedI18nValue } from '../../../../utils/axios/enrichErrorWithI18nMessage'
import i18n from '../../../../utils/i18n'

/**
 * Retrieves the translated title or description for an E-Invoice validation result.
 *
 * If the result object has a translation key, it uses i18n to translate based on the key.
 * Otherwise, it falls back to the Description or Detail field from the result object.
 *
 * @param key - The type of translation to retrieve: 'title' or 'description'
 * @param resultObject - The E-Invoice validation result object containing translation info
 * @returns The translated string, or an empty string if no translation is available
 */
export const getResultTranslation = (
  key: 'title' | 'description',
  resultObject?: EinvoiceValidationresult | null,
): string => {
  if (!resultObject) return ''

  const { t } = i18n

  const translationKey = resultObject?.TranslationKey?.Key
  const hasTranslationKey = !!translationKey

  if (hasTranslationKey) {
    // Use einvoice_rulesets with parameters
    const translationPath = `einvoice_rulesets.${translationKey}.${key}`
    const params =
      resultObject?.TranslationKey?.Parameters?.reduce((acc, param) => {
        // @ts-ignore
        acc[param.key] = getTransformedI18nValue(param?.value, param.dataType)
        return acc
      }, {} as Record<string, any>) || {}

    const translation = t(translationPath, params) as string
    return translation || ''
  } else {
    // Fallback to the original values
    const fallbackValue =
      key === 'title' ? resultObject?.Description : resultObject?.Detail

    return fallbackValue || ''
  }
}
